<script>
    import DesktopButton2 from '../../reusableitems/DesktopButton2.svelte';
</script>
    <div class="main-div">
        <div class="second-div">
            <p class="text1">STORYTELLERS & Opus</p>
            <p class="text2">
                SCRIPT
                <br />
                WRITERS
            </p>
            <p class="text3">
                On average, under 0.1% of scripts written within the United States
                ever make it to production. Most of the blood tears written by
                scriptwriters end up in an archive, never to be looked up upon
                again. Months and often years of work is lost.
            </p>
    
            <p class="text4">
                We are on a mission to change that. If you complete it, it will be
                produced, watched and enjoyed.
            </p>
            <div style="margin-top:6.296vh;">
                <DesktopButton2
                state = "StoryTeller"
                text1="Join Storytellers Governance Council"
                text2="(Scriptwriter Seat)"
                AnimationColor = #A53BD6
                width="31.611vh"
                    BorderColorAfter="0.0052vw solid #A53BD6"
                />
            </div>
        </div>
        <div class="image">
            <img src="/images/createmain/section3.png" alt="" width="100%" height="100%"/>
        </div>
    </div>
<style>
    .main-div {
        width: 110.889vh;
        height: 100vh;
        position: relative;
        
    }
    .second-div {
        width: 67.315vh;
        background-color: #f4eeec;
        height: 100vh;
        padding-left: 8.148vh;
    }
    p {
        font-family: "Orbitron";
        margin: 0;
    }
    .text1 {
        font-size: 1.296vh;
        font-weight: 400;
        padding-top: 24.352vh;
    }
    .text2 {
        color: #a53bd6;
        font-size: 5.556vh;
        line-height: 5.556vh;
        font-weight: 800;
        margin: 0;
        padding-top: 1.481vh;
    }
    .text3 {
        font-size: 1.296vh;
        font-weight: 400;
        width: 37.037vh;
        padding-top: 6.204vh;
        line-height: 1.815vh;
        letter-spacing: 0.055vw;
    }
    .text4 {
        font-size: 1.296vh;
        width: 39.722vh;
        font-weight: 700;
        letter-spacing: 0.09vh;
        padding-top: 5.37vh ;
        line-height: 2.041vh;
    }
    .image {
        position: absolute;
        left: 50.852vh;
        top: 24.537vh;
        width: 50.926vh ;
        height: 51.296vh;
    }
    .image::before{
        position: absolute;
        content: "";
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(255, 0, 0, 0)(255, 255, 255);
    }
</style>
